import buildPractitionerApplicationDocuments from "./buildPractitionerApplicationDocuments";

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** Keeps day/month/year in form state while the user is still typing. */
export function buildPartialDateValue({ day, month, year }) {
  return `${year ?? ""}-${month ?? ""}-${day ?? ""}`;
}

export function buildIsoDate({ day, month, year }) {
  if (!day || !month || !year) {
    return "";
  }
  const paddedDay = `${parseInt(day, 10)}`.padStart(2, "0");
  const paddedMonth = `${parseInt(month, 10)}`.padStart(2, "0");
  const paddedYear = `${parseInt(year, 10)}`.padStart(4, "0");
  const candidate = `${paddedYear}-${paddedMonth}-${paddedDay}`;
  return ISO_DATE.test(candidate) ? candidate : "";
}

function normalizeOptionalDate(value) {
  if (!value || !ISO_DATE.test(value)) {
    return null;
  }
  return value;
}

export default function buildPractitionerApplicationMutationInput(input) {
  const {
    insuranceEvidence,
    documents,
    insuranceExpiryDate,
    dateOfBirth,
    professionalBodies,
    ...rest
  } = input;

  const professionalBodyMemberships = (professionalBodies || []).map(
    ({ id, registrationNumber }) => ({
      professionalBodyId: id == null || id === "" ? id : String(id),
      registrationNumber: registrationNumber || ""
    })
  );

  return {
    ...rest,
    professionalBodyMemberships: JSON.stringify(professionalBodyMemberships),
    dateOfBirth: normalizeOptionalDate(dateOfBirth),
    insuranceExpiryDate: normalizeOptionalDate(insuranceExpiryDate),
    documents: buildPractitionerApplicationDocuments(documents, insuranceEvidence)
  };
}
